import {Questionnaire } from "../../models/open/questionnaire.model"

export interface QuestionnaireState{
    readonly questionnaire:Questionnaire;
}

export const initialState: Questionnaire = {};
// export const initialState: Readonly<Questionnaire> = {};